export default __webpack_public_path__ + "static/media/sportsbra-small-back-toobig.6ec87d6e.jpg";